import { Component } from '../../../libs/gin-tonic/helpers/compiler';

declare const Cookiebot: any;

@Component({ className: 'js-cookie-renew' })
export class CookieRenewComponent {
	constructor(private element: HTMLElement) {
		this.element.addEventListener('click', (e) => {
			e.preventDefault();
			Cookiebot.renew();
		});
	}
}
